import * as React from 'react';

const Exclamation = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4 21.3C16.3706 21.3 20.4 17.2706 20.4 12.3C20.4 7.32949 16.3706 3.30005 11.4 3.30005C6.42946 3.30005 2.40002 7.32949 2.40002 12.3C2.40002 17.2706 6.42946 21.3 11.4 21.3Z"
      fill="#ED0A34"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6766 7.42041C11.1243 7.42041 10.6766 7.86813 10.6766 8.42041C10.6766 8.97269 11.1243 9.42041 11.6766 9.42041H11.6872C12.2395 9.42041 12.6872 8.97269 12.6872 8.42041C12.6872 7.86813 12.2395 7.42041 11.6872 7.42041H11.6766ZM12.6766 12.2607C12.6766 11.7084 12.2289 11.2607 11.6766 11.2607C11.1243 11.2607 10.6766 11.7084 10.6766 12.2607V16.101C10.6766 16.6533 11.1243 17.101 11.6766 17.101C12.2289 17.101 12.6766 16.6533 12.6766 16.101V12.2607Z"
      fill="white"
    />
  </svg>
);

export default Exclamation;
